module.exports = __webpack_public_path__ + "img/logo-aliments-sante.af21b86f.svg";